export default [
  {
    fullName: 'Александр Собачкин',
    jobTitle: 'Директор центра компетенций инженерного анализа и продуктовой разработки',
    description: 'Т1 Интеграция',
    photo: require('@/assets/speakers/Собачкин А.А._5.jpeg')
  },
  {
    fullName: 'Алексей Харитонович',
    jobTitle: 'Директор направления развития продуктов инженерного моделирования',
    description: 'Т1 Интеграция',
    photo: require('@/assets/speakers/Харитонович А._2.jpg')
  },
  {
    fullName: 'Дмитрий Фомичев',
    jobTitle: 'Директор по математическому моделированию',
    description: 'Госкорпорация "Росатом"',
    photo: require('@/assets/speakers/Фомичев Дмитрий.jpg')
  },
  {
    fullName: 'Дмитрий Громов',
    jobTitle: 'Заместитель начальника отдела экспертизы программ для ЭВМ',
    description: 'ФБУ «НТЦ ЯРБ»',
    photo: require('@/assets/speakers/IMG_6647.jpg')
  },
  {
    fullName: 'Рустам Мулляджанов',
    jobTitle: 'Директор по научно-техническому развитию',
    description: '«Научный инжиниринг»',
    photo: require('@/assets/speakers/Рустам Мулляджанов.jpg')
  },
  {
    fullName: 'Денис Капица',
    jobTitle: 'Начальник лаборатории инженерных расчетов',
    description: 'АО «Атомэнергопроект»',
    photo: require('@/assets/speakers/307.jpg')
  },
  {
    fullName: 'Павел Поляков',
    jobTitle: 'Начальник лаборатории тепловых исследований',
    description: 'НИЦ «Курчатовский институт»',
    photo: require('@/assets/speakers/Павел Поляков.jpg')
  },
  {
    fullName: 'Геннадий Новаковский',
    jobTitle: 'Ведущий инженер-проектировщик',
    description: 'Т1 Интеграция',
    photo: require('@/assets/speakers/Геннадий Новаковский.jpg')
  }
]
